/*
 * Panel template for the static project navigation (assets over shares),
 * used by non-web clients that render outside the resizable accordion nav.
 */
import type {
  PanelArea,
  PanelsBreakpointTemplate,
  PanelsTemplate,
  StaticProjectNavigationPanelArea,
} from '../types';

const PANEL_ROW_MIN_HEIGHT = 200;

function baseTemplate(): PanelsBreakpointTemplate {
  return {
    areas: [['assets'], ['shares']],
    resizers: { assets: 'bottom' },
    columns: [{ key: 'assets', defaultSize: '1fr', isToggleable: false }],
    rows: [
      {
        key: 'assets',
        defaultMin: PANEL_ROW_MIN_HEIGHT,
        defaultSize: '1fr',
        isToggleable: false,
      },
      {
        key: 'shares',
        defaultMin: PANEL_ROW_MIN_HEIGHT,
        defaultSize: '1fr',
        isToggleable: false,
      },
    ],
  };
}

export const getDefaultVisiblePanels =
  (): Array<StaticProjectNavigationPanelArea> => ['assets', 'shares'];

export function getPanelState(__visible: Array<PanelArea>): PanelsTemplate {
  return {
    base: baseTemplate(),
    tablet: baseTemplate(),
    desktop: baseTemplate(),
    visible: ['assets', 'shares'],
  };
}
